module.exports = __webpack_public_path__ + "static/ma-9-sq-5e3f9b6268f216f7681fab39ee45d015.png";